import { createContext } from 'react';

interface TrackingGeneral {
  page: any;
  general: any;
}

const TrackingContext = createContext<TrackingGeneral>({} as TrackingGeneral);

export default TrackingContext;
